&nbsp;
<footer class="mdc-layout-grid__inner inner_footer">
	<div class="mdc-layout-grid__cell--span-12 section">
		<div class="four_col">
			<!--Used Cars in Iraq-->
			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<h1 class="header n126">{{ locale.translations['footer']['cars-iraq']['n490'] }}</h1>

				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291,location:89}" (click)="onClickShortcuts()">{{ locale.translations['footer']['cars-iraq']['n491'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291,location:84}" (click)="onClickShortcuts()">{{ locale.translations['footer']['cars-iraq']['n492'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291,location:82}" (click)="onClickShortcuts()">{{ locale.translations['footer']['cars-iraq']['n493'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291,location:83}" (click)="onClickShortcuts()">{{ locale.translations['footer']['cars-iraq']['n494'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291,location:85}" (click)="onClickShortcuts()">{{ locale.translations['footer']['cars-iraq']['n495'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291}" (click)="onClickShortcuts()">{{ locale.translations['footer']['cars-iraq']['n496'] }}</h2>		

			</div>
			<!--end of Used Cars in Iraq-->				

			<!--Properties in Iraq-->
			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<h1 class="header n126">{{ locale.translations['footer']['properties-iraq']['n497'] }}</h1>

				<h2 [routerLink]="['/c/17']" [queryParams]="{subCatID:314}" (click)="onClickShortcuts()">{{ locale.translations['footer']['properties-iraq']['n498'] }}</h2>
				<h2 [routerLink]="['/c/17']" [queryParams]="{subCatID:315}" (click)="onClickShortcuts()">{{ locale.translations['footer']['properties-iraq']['n499'] }}</h2>
				<h2 [routerLink]="['/c/17']" [queryParams]="{location:82}" (click)="onClickShortcuts()">{{ locale.translations['footer']['properties-iraq']['n500'] }}</h2>
				<h2 [routerLink]="['/c/17']" [queryParams]="{location:83}" (click)="onClickShortcuts()">{{ locale.translations['footer']['properties-iraq']['n501'] }}</h2>
				<h2 [routerLink]="['/c/17']" [queryParams]="{location:89}" (click)="onClickShortcuts()">{{ locale.translations['footer']['properties-iraq']['n502'] }}</h2>
				<h2 [routerLink]="['/c/17']" (click)="onClickShortcuts()">{{ locale.translations['footer']['properties-iraq']['n503'] }}</h2>				

			</div>
			<!--end of Properties in Iraq-->

			<!--Vehicles for sale-->
			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<h1 class="header n126">{{ locale.translations['footer']['vehicles-sale']['n504'] }}</h1>

				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:291}" (click)="onClickShortcuts()">{{ locale.translations['footer']['vehicles-sale']['n505'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:298}" (click)="onClickShortcuts()">{{ locale.translations['footer']['vehicles-sale']['n506'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:293}" (click)="onClickShortcuts()">{{ locale.translations['footer']['vehicles-sale']['n507'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:297}" (click)="onClickShortcuts()">{{ locale.translations['footer']['vehicles-sale']['n508'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:294}" (click)="onClickShortcuts()">{{ locale.translations['footer']['vehicles-sale']['n509'] }}</h2>
				<h2 [routerLink]="['/c/15']" [queryParams]="{subCatID:292}" (click)="onClickShortcuts()">{{ locale.translations['footer']['vehicles-sale']['n510'] }}</h2>

			</div>
			<!--end of Vehicles for sale-->
			
			<!--Used Electronics in Iraq-->
			<div class="col_one" [ngClass]="{ mobile: viewport.type === 'mobile' }">
				<h1 class="header n126">{{ locale.translations['footer']['electronics-sale']['n511'] }}</h1>

				<h2 [routerLink]="['/c/16']" [queryParams]="{subCatID:302}" (click)="onClickShortcuts()">{{ locale.translations['footer']['electronics-sale']['n512'] }}</h2>
				<h2 [routerLink]="['/c/16']" [queryParams]="{subCatID:304}" (click)="onClickShortcuts()">{{ locale.translations['footer']['electronics-sale']['n513'] }}</h2>
				<h2 [routerLink]="['/c/16']" [queryParams]="{subCatID:311}" (click)="onClickShortcuts()">{{ locale.translations['footer']['electronics-sale']['n514'] }}</h2>
				<h2 [routerLink]="['/c/16']" [queryParams]="{subCatID:307}" (click)="onClickShortcuts()">{{ locale.translations['footer']['electronics-sale']['n515'] }}</h2>
				<h2 [routerLink]="['/c/16']" [queryParams]="{subCatID:363}" (click)="onClickShortcuts()">{{ locale.translations['footer']['electronics-sale']['n516'] }}</h2>
				<h2 [routerLink]="['/c/16']" [queryParams]="{subCatID:306}" (click)="onClickShortcuts()">{{ locale.translations['footer']['electronics-sale']['n517'] }}</h2>				

			</div>
			<!--end of Electronics in Iraq-->					
		</div>
	</div>			
</footer>
